import { IFormatRegistry, IFormatRepository } from "../../../domain/format";
import { FormatRepository } from ".";

export class FormatRegistry implements IFormatRegistry {
  constructor(private _getToken: () => string) {
  }

  getFormatRepository(): IFormatRepository {
    return new FormatRepository(this._getToken);
  }
}
